import findClosestDay from "../resolve/find-closest-day";
import sortByDates from "../chronology/sort-by-dates";
import isCurrentPeriod from "../chronology/current/is-current-period";

export default function autoDay(
  date, // May be `null` for current date.
  { parentVolume, parentSeason, parentSeasonContentForSchoolLevel },
  { state, getters },
) {
  if (!getters.containerLoaded) {
    return null;
  }

  // The parent season content for school level has no days, or is null.
  if (!parentSeasonContentForSchoolLevel?.days.length) {
    return null;
  }

  // Sort the days to easily grab the next, previous, first or last one.
  sortByDates(parentSeasonContentForSchoolLevel.days);

  // If we are visiting a different school year (volume),
  // then we are going to *always* return the first day of each season.
  // Flipping through a non-current volume is like flipping through
  // a catalog of material, and no longer an experience bound to
  // the actual current real-time.
  if (!isCurrentPeriod(date, parentVolume)) {
    return parentSeasonContentForSchoolLevel.days[0];
  }

  // If the parent season is the current season, then we will be able
  // to match the next following available day.
  // Otherwise, we attempt to fall back to the most recent past day
  // in the same season.
  if (isCurrentPeriod(date, parentSeason)) {
    // If the parent 'season content for school level' contains a day record
    // for the given date or a near future or recent past date, then we want
    // to use that one.

    const closestDay = findClosestDay(date, parentSeasonContentForSchoolLevel, {
      state,
      getters,
    });
    if (closestDay) {
      return closestDay;
    }

    // No current, near future or recent past day was found.
    // We have no choice but to fall through ot the first or last
    // day of the season.
    // Note: If the `parentSeasonContentForSchoolLevel` has
    // no day records, then we already returned `null` above!
  }

  // As the parent season is not the current season, it must be
  // either a past or a future season. We take the simple route
  // and pick the last day for past seasons, and the first day
  // for future seasons.

  // If active season is in the past, then use last day of that season.
  const lastDay =
    parentSeasonContentForSchoolLevel.days[
      parentSeasonContentForSchoolLevel.days.length - 1
    ];
  if (new Date(lastDay.date) < new Date()) {
    return lastDay;
  }

  // The active season must be a future season.
  // Return the selected school level's and season's first day.
  return parentSeasonContentForSchoolLevel.days[0];
}
